module.exports = __webpack_public_path__ + "static/media/newNGC.8f8f204a.png";